import CONSTANTS from "../../../app-consts/appConstants";
import { PartnerDetails } from "../../../types";

export type LookupPayload = any;

type ResolveLookupOverridesInput = {
  partnerCode: string;
  partnerDetails: PartnerDetails;
  primaryLookup?: string;
  payload: LookupPayload;
  partnerMemberId?: string;
  lookupType?: string;
  tollFreeNumber?: string;
  uuid?: string
};

type ResolveLookupOverridesOutput = {
  partnerMemberId?: string;
  lookupType?: string;
  tollFreeNumber?: string;
  uuid?: string
};

type PartnerOverrideRule = (
  input: ResolveLookupOverridesInput,
  current: ResolveLookupOverridesOutput
) => ResolveLookupOverridesOutput;

//Config for the enhanced auth override
export const enhancedAuthpartnerOverridesConfig: Record<string, PartnerOverrideRule> = {
  CRA: (input, current) => {
    const { partnerDetails, payload, partnerMemberId } = input;
    if (partnerDetails?.enhancedAuthPartner && !partnerMemberId) {
      return {
        ...current,
        partnerMemberId: payload.rentalAgreementNumber,
        lookupType: CONSTANTS.RENTAL_AGREEMENT_LOOKUP,
      };
    }
    return current;
  },

  V15: (input, current) => {
    const { partnerDetails, payload, lookupType } = input;
    if (partnerDetails?.enhancedAuthPartner && !lookupType) {
      return {
        ...current,
        lookupType: 'vinOnly',
        tollFreeNumber: payload.channelID || current.tollFreeNumber,
      };
    }
    return current;
  },

  ENC: (input, current) => {
    const { partnerDetails, payload } = input;
    if (partnerDetails?.enhancedAuthPartner) {
      return {
        ...current,
        lookupType: 'policyNumber',
        partnerMemberId: payload.policyNumber,
      };
    }
    return current;
  },

  JJ: (input, current) => {
    const { partnerDetails, payload } = input;
    if (partnerDetails?.enhancedAuthPartner) {
      return {
        ...current,
        lookupType: 'uuidLookup',
        uuid: payload.uuid,
      };
    }
    return current;
  },
  L28: (input, current) => {
    const { partnerDetails, payload } = input;
    if (partnerDetails?.enhancedAuthPartner) {
      return {
        ...current,
        lookupType: 'phoneNumber',
        uuid: payload.phoneNumber,
      };
    }
    return current;
  }
};


export function enhancedAuthLookupOverrides(
  input: ResolveLookupOverridesInput
): ResolveLookupOverridesOutput {
  const {
    partnerCode,
    partnerMemberId,
    lookupType,
    tollFreeNumber,
  } = input;

  const initial: ResolveLookupOverridesOutput = {
    partnerMemberId,
    lookupType,
    tollFreeNumber
  };

  const applyRule = enhancedAuthpartnerOverridesConfig[partnerCode];
  return applyRule ? applyRule(input, initial) : initial;
}
